import React, { useState, useEffect, useRef } from "react";
import Footer from "components/Footers/Footer.js";
import IndexNavbarr from "components/Navbars/IndexNavbarr";
import truck from "assets/img/truck.png";
import girl from "assets/img/girl.jpg";
import Krones from "assets/img/Krones.webp";
import Evoguard from "assets/img/Evoguard.webp";
import Ampco from "assets/img/Ampco.png";
import Perfinox from "assets/img/Perfinox.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import Slider2 from "components/Homepage/Slider2";
import bgfruits from "assets/img/bgfruits.jpg";
import tomatoo from "assets/img/tomatoo.png";
import conveying from "assets/img/conveying.png";
import newbg from "assets/img/newbg.jpg";
import newimg from "assets/img/newimg.png";
import icon5 from "assets/img/icon5.png";
import icon6 from "assets/img/icon6.png";
import icon7 from "assets/img/icon7.png";
import icon8 from "assets/img/icon8.png";
import icon9 from "assets/img/icon9.png";
import vapour from "assets/img/vapour.jpg";
import bgg3 from "assets/img/bgg3.png";
import mixing from "assets/img/mixing.png";
import thermal from "assets/img/thermal.jpg";


export default function Product() {
  const [buttonPopup, setButtonPopup] = useState(false);
  return (
    <section className="poppins">
      <IndexNavbarr />

      <section className="xl:pt-0 lg:pt-0 md:pt-24 pt-20">
        <div
          className="relative xl:h-400 lg:h-300 md:h-240 h-200-px"
          style={{
            backgroundImage: `url(${newbg})`,
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
          }}
        >
          {/* Black Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
          ></div>

          <div style={{ position: "relative", zIndex: 1 }}>
            <div className="xl:gap-0">
              <div className="xl:pt-32 lg:pt-24 md:pt-20 pt-16">
                <h1 className="xl:text-7xl lg:text-5xl md:text-4xl text-4xl text-center text-white uppercase font-bold fade-item-1">
                  product
                </h1>

                <div>
                  <div className="flex items-center justify-center bg-[#FDF5E6] rounded-lg xl:mt-6 lg:mt-4 mt-4">
                    <div
                      className="xl:w-2/12 lg:w-2/12 md:w-2/12 py-2 px-2 flex items-center gap-2 justify-center fade-item-2"
                      style={{ border: "1px dashed white" }}
                    >
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        <a href="/homepage1">Home</a>
                      </span>
                      <span className="text-white font-semibold"> »</span>
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        Product
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl:pt-16  lg:pt-16  md:pt-16  pt-12  headerbg1 xl:px-0 px-4 ">
        <div
          className=" bg-white rounded-md xl:pt-16  lg:pt-16 lg:px-4 md:pt-16 pt-12  container mx-auto shadow-xl grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 grid-cols-1"
          style={{ borderBottom: "1px solid #f7f7f7" }}
        >
          <div className="">
          <div className="mb-4"style={{ borderRight: "1px solid #d5d1d17d" }}>
            <div className=" flex justify-center">
              <img className="w-16 animated-image" src={icon5} alt="" />
            </div>
            <p className="  lg:text-base xl:text-base md:text-sm text-base text-blackk xl:pb-12 lg:pb-12 md:pb-12 text-lg pb-12 text-center xl:pt-4 lg:pt-4 pt-4 ">
              Innovating Food Solutions<br></br> for a Better Tomorrow
            </p>
            </div>
          </div>

          <div className="">
          <div className="mb-4"style={{ borderRight: "1px solid #d5d1d17d" }}>
            <div className=" flex justify-center">
              <img className="w-16 animated-image" src={icon6} alt="" />
            </div>
            <p className="xl:pt-4 lg:pt-4 pt-4 lg:text-base xl:text-base md:text-sm text-base text-blackk  xl:pb-12 lg:pb-12 md:pb-12 text-lg pb-12 text-center">
              Revolutionizing Food Processing<br></br> with Innovation
            </p>
            </div>
          </div>

          <div className="">
          <div className="mb-4"style={{ borderRight: "1px solid #d5d1d17d" }}>
            <div className=" flex justify-center">
              <img className="w-16 animated-image" src={icon7} alt="" />
            </div>
            <p className="xl:pt-4 lg:pt-4 pt-4 lg:text-base xl:text-base md:text-sm text-base text-blackk  xl:pb-12 lg:pb-12 md:pb-12  pb-12 text-center">
              Advancing Food Technology<br></br> with Smart Solutions
            </p>
            </div>
          </div>
          

          {/* extra div */}
          <div className="xl:hidden lg:hidden md:block sm:hidden hidden"></div>

          <div className="">
          <div className="mb-4">
            <div className=" flex justify-center">
              <img className="w-16 animated-image" src={icon8} alt="" />
            </div>
            <p className="xl:pt-4 lg:pt-4 pt-4 lg:text-base xl:text-base md:text-sm text-blackk  xl:pb-12 lg:pb-12 text-lg pb-12 text-center">
              Transforming Ideas into<br></br> Reality with Innovation
            </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="headerbg1 xl:pt-24 xl:pb-24 lg:pt-20 lg:pb-20 md:pt-16 md:pb-16 pt-12 pb-12">
        <div className="container mx-auto xl:px-0 lg:px-0 md:px-0 px-4">
          <h1 className="xl:text-6xl lg:text-4xl md:text-3xl text-2xl text-black text-center font-semibold ">
            <span className="text-blue">Customer Praise</span> for Our<br></br>{" "}
            Organic Online Store
          </h1>
          <div className="xl:ml-32 lg:ml-32 md:ml-16">
            <div className="xl:block lg:block md:block sm:hidden hidden">
              <Slider2 />
            </div>
            
           
          </div>
        </div>
      </section> */}

      <section className="headerbg1 xl:pt-16 lg:pt-16 md:pt-16 pt-12 xl:pb-8 md:pb-8 lg:pb-8">
      <p className="xl:text-xl lg:text-lg md:text-lg text-lg font-bold text-blue text-center uppercase">
          Products
        </p>
        <h1 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-bold text-black text-center pt-4">
          Cutting-Edge Equipment for<br></br> Efficient Processing
        </h1>
      <div className="grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 grid-cols-1 container mx-auto xl:gap-6 lg:gap-4 gap-4 xl:px-0 px-4 xl:pt-8 md:pt-8 pt-8 lg:pt-8">
      
        {/* Conveying Card */}
        <div className="h-full">
          <div className="bg-white shadow-lg rounded-xl overflow-hidden relative h-full">
            <div className="relative">
              <img
                className="xl:w-12/12 lg:w-12/12 w-12/12"
                src={Krones}
                alt="Conveying"
              />
              <div
                className="flex justify-end items-center xl:mr-8 xl:-mt-12 lg:mr-4 lg:-mt-12 md:-mt-8 mr-4 -mt-8"
                style={{ position: "relative", zIndex: 2 }}
              >
                <div className="blue xl:p-10 lg:p-8 md:p-4 p-8 rounded-lg w-12 h-12 flex justify-center items-center">
                  <i className="fas fa-tractor text-white xl:text-2xl"></i>
                </div>
              </div>
            </div>
            <div className="xl:p-4 lg:p-4 md:p-4 p-4">
              <h3 className="text-black font-semibold xl:text-xl">Krones Group</h3>
              <p className="text-para pt-2 text-base">
              Krones Group is a global leader in beverage and liquid food processing and packaging solutions. 
              It provides innovative,complete production for industries worldwide.
              </p>
              <a href="https://www.krones.com/en/index.php">
                <button className="xl:px-8 xl:py-2 xl:mt-4 rounded-md borderblue text-green box xl:text-lg font-semibold px-2 py-1 mt-4">
                  Learn more
                </button>
              </a>
            </div>
          </div>
        </div>

        {/* Mixing Card */}
        <div className="h-full">
          <div className="bg-white shadow-lg rounded-xl overflow-hidden relative h-full">
            <div className="relative">
              <img
                className="xl:w-12/12 lg:w-12/12 w-12/12"
                src={Evoguard}
                alt="Mixing"
              />
              <div
                className="flex justify-end items-center xl:mr-8 xl:-mt-12 lg:mr-8 lg:-mt-12 md:-mt-8 mr-4 -mt-8"
                style={{ position: "relative", zIndex: 2 }}
              >
                <div className="blue xl:p-10 lg:p-8 md:p-4 p-8 rounded-lg w-12 h-12 flex justify-center items-center">
                  <i className="fas fa-blender text-white xl:text-2xl"></i>
                </div>
              </div>
            </div>
            <div className="xl:p-4 lg:p-4 md:p-4 p-4">
              <h3 className="text-black font-semibold xl:text-xl">Evoguard</h3>
              <p className="text-para pt-2 text-base">
              Evoguard, a subsidiary of Krones AG, provides high-performance valves and pumps for the beverage, food, and pharmaceutical industries Established in 2014.
              </p>
              <a href="https://youtu.be/eJf1Z3tGLMg?si=7Kp3N3dJOkhr_gka">
                <button className="xl:px-8 xl:py-2 xl:mt-4 rounded-md borderblue text-blue box xl:text-lg font-semibold px-2 py-1 mt-4">
                  Learn More
                </button>
              </a>
            </div>
          </div>
        </div>

        {/* Thermal Treatment Card */}
        <div className="h-full">
          <div className="bg-white shadow-lg rounded-xl overflow-hidden relative h-full">
            <div className="relative">
              <img
                className="xl:w-12/12 lg:w-12/12 w-12/12"
                src={Ampco}
                alt="Ampco"
              />
              <div
                className="flex justify-end items-center xl:mr-8 xl:-mt-12 lg:mr-8 lg:-mt-12 md:-mt-8 mr-4 -mt-8"
                style={{ position: "relative", zIndex: 2 }}
              >
                <div className="blue xl:p-10 lg:p-8 md:p-4 p-8 rounded-lg w-12 h-12 flex justify-center items-center">
                  <i className="fas fa-fire text-white xl:text-2xl"></i>
                </div>
              </div>
            </div>
            <div className="xl:p-4 lg:p-4 md:p-4 p-4">
              <h3 className="text-black font-semibold xl:text-xl">
              Ampco
              </h3>
              <p className="text-para pt-2 text-base">
              Ampco Pumps Company is a leading manufacturer of sanitary, marine, and industrial pumps and mixers for the food, beverage, dairy, and pharmaceutical industries.
              </p>
              <a href="https://www.youtube.com/watch?v=ewmgG03ptPY">
                <button className="xl:px-8 xl:py-2 xl:mt-4 rounded-md borderblue text-blue box xl:text-lg font-semibold px-2 py-1 mt-4">
                  Learn More
                </button>
              </a>
            </div>
          </div>
        </div>

        {/* New Packaging Card */}
        <div className="h-full">
          <div className="bg-white shadow-lg rounded-xl overflow-hidden relative h-full">
            <div className="relative">
              <img
                
                src={Perfinox}
                alt="Perfinox"
              />
              <div
                className="flex justify-end items-center xl:mr-8 xl:-mt-12 lg:mr-8 lg:-mt-12 md:-mt-8 mr-4 -mt-8"
                style={{ position: "relative", zIndex: 2 }}
              >
                <div className="blue xl:p-10 lg:p-8 md:p-4 p-8 rounded-lg w-12 h-12 flex justify-center items-center">
                  <i className="fas fa-box text-white xl:text-2xl"></i>
                </div>
              </div>
            </div>
            <div className="xl:p-4 lg:p-4 md:p-4 p-4">
              <h3 className="text-black font-semibold xl:text-xl">Perfinox</h3>
              <p className="text-para pt-2 text-base">
              Perfinox, established in 1997 in Portugal, specializes in designing and manufacturing advanced processing equipment for the food, beverage and cosmetics industries.
              </p>
              <a href="https://www.youtube.com/watch?v=AuFnbnjXGl0">
                <button className="xl:px-8 xl:py-2 xl:mt-4 rounded-md borderblue text-green box xl:text-lg font-semibold px-2 py-1 mt-4">
                  Learn More
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  

      {/* <section className="headerbg1 xl:pt-16 xl:pb-24 lg:pt-12 lg:pb-20 md:pt-12 md:pb-16 pt-12 pb-12">
        <p className="xl:text-xl lg:text-lg md:text-lg text-lg font-bold text-blue text-center uppercase">
          Products
        </p>
        <h1 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-bold text-black text-center pt-4">
          Cutting-Edge Equipment for<br></br> Efficient Processing
        </h1>

        <div className="container mx-auto grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xl:gap-6 lg:gap-4 gap-4 xl:px-0 px-4 xl:mt-16 lg:mt-16 md:mt-12 mt-8">
          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={silos}
                      alt="Basket"
                    />
                  </div>
                </div>

             
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Silos
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Silos store milk in dairy processing, maintaining
                    temperature and hygiene for quality and efficiency in cheese
                    production.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={storagetanks}
                      alt="Basket"
                    />
                  </div>
                </div>

         
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Storage Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Storage tanks hold milk in dairy processing, maintaining
                    hygiene, preventing contamination, and ensuring a steady
                    supply.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={processtanks}
                      alt="Basket"
                    />
                  </div>
                </div>

                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Process Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Process tanks mix, heat, cool, and ferment milk, ensuring
                    temperature control, hygiene, and product consistency.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={mixingtank}
                      alt="Basket"
                    />
                  </div>
                </div>

              
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Mixing Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Mixing tanks blend ingredients uniformly, ensuring texture,
                    emulsification, and temperature control for quality dairy
                    products.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={cpitanks}
                      alt="Basket"
                    />
                  </div>
                </div>

               
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    CIP Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    CIP tanks store and circulate cleaning solutions, sanitizing
                    equipment to ensure hygiene, efficiency, and food safety.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-10/12 w-8/12 object-contain"
                      src={incubationtanks}
                      alt="Basket"
                    />
                  </div>
                </div>

              
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Incubation Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Incubation tanks culture and ferment milk, maintaining
                    optimal conditions for texture and flavor development.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={buttermeltingtank}
                      alt="Basket"
                    />
                  </div>
                </div>

               
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl   text-xl pt-2">
                    Butter Melting Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Butter melting tanks gently liquefy butter, ensuring  preventing burning, and maintaining temperature
                    control.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={jackedtedtanks}
                      alt="Basket"
                    />
                  </div>
                </div>

               
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Jacketed Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Jacketed tanks regulate temperature by circulating heating
                    or cooling fluids, ensuring precise thermal control.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={ribbonblender}
                      alt="Basket"
                    />
                  </div>
                </div>

               
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Ribbon Blenders
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Ribbon blenders mix powders and granules evenly, ensuring
                    consistency and product quality.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={drymixingtank}
                      alt="Basket"
                    />
                  </div>
                </div>

           
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Dry Mixing Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Dry mixing tanks blend powdered ingredients evenly,
                    preventing clumps and ensuring consistency.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={milktank}
                      alt="Basket"
                    />
                  </div>
                </div>


                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Milk Road Tankers
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Milk road tankers transport milk under controlled
                    conditions, ensuring freshness and safe delivery.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue  rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-230 lg:h-250 md:h-240 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={insulatedtank}
                      alt="Basket"
                    />
                  </div>
                </div>

           
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-bold xl:text-xl  text-xl pt-2">
                    Insulated Tanks
                  </h3>
                  <p className="text-para mt-1 text-base">
                    Insulated tanks maintain stable temperatures, preserving
                    quality and ensuring food safety.
                  </p>
                  <a href="/contact">
                    <p className=" text-blue rounded-md mt-2">Know More ➜</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="">
        <div
          className="xl:pt-16 xl:pb-16 lg:pt-12 lg:pb-12 md:pt-16 md:pb-16 pt-12 pb-12 flex justify-end items-center animated-bg"
          style={{
            backgroundImage: `url(${bgg3})`,
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container mx-auto xl:px-0 px-4  flex justify-end">
            <div
              className=" bg-opacity-90 xl:p-4 lg:p-4 md:p-4 p-4 rounded-lg shadow-lg  "
              style={{ backgroundColor: "#FFFFFFE0" }}
            >
              <h2 className="xl:text-3xl lg:text-2xl md:text-2xl text-2xl font-semibold text-blackk ">
                Why Choose Our Solutions ?
              </h2>

              <div className="xl:block lg:block md:block sm:hidden hidden">
                <p className="text-para xl:text-base lg:text-base text-base lg:mt-4 xl:mt-4 mt-4 ">
                  Our cutting-edge technologies enhance food processing
                  efficiency,
                  <br></br> ensuring superior quality and optimized
                  manufacturing.
                </p>
              </div>

              {/* mobile view */}
              <div className="xl:hidden lg:hidden md:hidden sm:block block">
                <p className="text-para text-base  mt-4 font-semibold">
                  Our cutting-edge technologies enhance food processing
                  efficiency, ensuring superior quality and optimized
                  manufacturing.
                </p>
              </div>

              <div className="xl:mt-6 lg:mt-4 mt-4">
                <div className="relative ">
                  <h3 className="xl:text-xl lg:text-xl md:text-xl text-xl font-semibold text-blackk flex items-center">
                    <i className="fas fa-cogs text-blue mr-2 text-2xl"></i>{" "}
                    Advanced Processing Equipment
                  </h3>

                  <div className="xl:block lg:block md:block sm:hidden hidden">
                    <p className="text-para xl:text-base lg:text-base text-base lg:pt-2 xl:pl-8 xl:pt-4 pt-2">
                      Our state-of-the-art machinery ensures faster, more
                      efficient
                      <br></br> food production with consistent quality output.
                    </p>
                  </div>
                  {/* mobile view */}
                  <div className="xl:hidden lg:hidden md:hidden sm:block block">
                    <p className="text-para text-base pt-2 ">
                      Our state-of-the-art machinery ensures faster, more
                      efficient food production with consistent quality output.
                    </p>
                  </div>
                </div>

                <div className="relative xl:mt-6 lg:mt-4 mt-4">
                  <h3 className="xl:text-xl lg:text-xl md:text-xl text-xl font-semibold text-blackk flex items-center">
                    <i className="fas fa-industry text-blue mr-2 text-2xl"></i>{" "}
                    Precision Manufacturing Solutions
                  </h3>

                  <div className="xl:block lg:block md:block sm:hidden hidden">
                    <p className="text-para  xl:text-base lg:text-base text-base pt-2 lg:pt-2 xl:pl-8 xl:pt-4">
                      We provide tailored manufacturing solutions to enhance
                      <br></br> productivity and meet evolving industry demands.
                    </p>
                  </div>
                  {/* mobile view */}
                  <div className="xl:hidden lg:hidden md:hidden sm:block block">
                    <p className="text-para text-base pt-2 ">
                      We provide tailored manufacturing solutions to enhance
                      productivity and meet evolving industry demands.
                    </p>
                  </div>
                </div>
              </div>

              <div className="xl:mt-6 lg:mt-4 mt-4">
                <a href="/service">
                  <button className="blue text-white font-semibold xl:py-4 xl:px-6 lg:px-4 lg:py-2 rounded-lg hover:bg-green-700 px-2 py-2">
                    Explore Our Solutions <span className="ml-2">+</span>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </section>
  );
}
